import { List, ListItemButton, ListItemIcon, Typography } from '@mui/material';
import { useGroupSelectContext } from '../../context';

export function GroupsList() {
  const { groups, setSelectedGroup, selectedGroup } = useGroupSelectContext();

  return (
    <List
      sx={{
        border: 'none',
        p: 0,
        flex: 2,
        backgroundColor: '#F9FAFB',
        height: '100%',
      }}
    >
      {groups.map((group) => {
        const isSelected = group.name === selectedGroup;

        if (group.hidden) return null;

        return (
          <ListItemButton
            disableRipple
            disableGutters
            sx={{
              p: '10px',
              display: 'flex',
              gap: '10px',
              justifyContent: 'flex-start',
              '&.Mui-selected': {
                backgroundColor: '#F2F5FF',
                '&:hover': {
                  backgroundColor: '#F2F5FF',
                  color: '#000',
                },
              },
              '&:hover': {
                backgroundColor: '#F2F5FF',
                color: '#000',
              },
            }}
            selected={isSelected}
            key={group.name}
            onClick={() => {
              setSelectedGroup(group.name);
            }}
          >
            {group.icon && (
              <ListItemIcon sx={{ minWidth: 0 }}>
                {typeof group.icon === 'string' && <i className={group.icon} style={{ fontSize: '20px', color: '#667085' }} />}
                {typeof group.icon !== 'string' && group.icon}
              </ListItemIcon>
            )}

            <Typography
              sx={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                overflowWrap: 'break-word',
                color: 'var(--Black, #000)',
                fontFamily: 'Inter',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '24px',
              }}
            >
              {group.label}
            </Typography>

            {group.afterContent}
          </ListItemButton>
        );
      })}
    </List>
  );
}
